import { Stats } from 'react-instantsearch-dom'

export default function StatsComponent({ isAccount }) {
    return (
        <Stats
            translations={{
                stats(nbHits) {
                    if (isAccount) {
                        return `Prekės (${nbHits})`
                    }
                    return `Rasta prekių: ${nbHits}`
                }
            }}
        />
    )
}
